import { Reveal, ChapterLabel } from "@/components/site/Reveal";
import { CONTACT } from "@/lib/content";
import { WhatsAppIcon, TikTokIcon } from "@/components/site/icons";
import { Phone, Mail, Globe, Facebook, Instagram } from "lucide-react";

export default function Kontakt() {
  return (
    <section
      id="kontakt"
      data-testid="section-kontakt"
      className="relative py-20 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <ChapterLabel index={3} label="So erreichst du mich" color="text-brand-green" />
        <Reveal className="mt-6 max-w-2xl">
          <h2 className="font-heading font-bold text-ink text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Ich bin für dich da
          </h2>
          <p className="mt-4 text-lg md:text-xl leading-relaxed text-ink-muted">
            Hast du einen Igel gefunden oder eine Frage? Melde dich einfach – am
            besten telefonisch, wenn es dringend ist.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <Reveal
            as="a"
            href={CONTACT.phoneHref}
            data-testid="contact-phone"
            className="group rounded-[2rem] bg-brand-pink p-8 md:p-10 shadow-card text-white transition-transform duration-300 hover:-translate-y-1.5 block"
          >
            <span className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center">
              <Phone className="w-7 h-7" />
            </span>
            <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-white/80">
              Telefon · nur Notfälle
            </p>
            <p className="mt-1 font-heading font-extrabold text-2xl md:text-[1.7rem]">
              {CONTACT.phone}
            </p>
          </Reveal>

          <Reveal
            as="a"
            href={CONTACT.emailHref}
            delay={0.08}
            data-testid="contact-email"
            className="group rounded-[2rem] bg-white p-8 md:p-10 shadow-soft border border-ink/5 transition-transform duration-300 hover:-translate-y-1.5 block"
          >
            <span className="w-14 h-14 rounded-full bg-brand-orange/12 flex items-center justify-center">
              <Mail className="w-7 h-7 text-brand-orange" />
            </span>
            <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-ink-muted">
              E-Mail
            </p>
            <p className="mt-1 font-heading font-bold text-lg md:text-2xl text-ink break-all">
              {CONTACT.email}
            </p>
          </Reveal>

          <Reveal
            delay={0.16}
            data-testid="contact-web"
            className="rounded-[2rem] bg-white p-8 md:p-10 shadow-soft border border-ink/5"
          >
            <span className="w-14 h-14 rounded-full bg-brand-green/12 flex items-center justify-center">
              <Globe className="w-7 h-7 text-brand-green" />
            </span>
            <p className="mt-6 text-sm font-semibold uppercase tracking-wider text-ink-muted">
              Im Netz
            </p>
            <p className="mt-1 font-heading font-bold text-xl md:text-2xl text-ink">
              {CONTACT.domain}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4">
          <span className="text-lg font-semibold text-ink">Schreib &amp; folge mir:</span>
          <div className="flex flex-wrap gap-3">
            <a
              href={CONTACT.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp"
              aria-label="WhatsApp"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-3 shadow-soft font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:bg-[#1ebe5b]"
            >
              <WhatsAppIcon className="w-5 h-5" /> WhatsApp
            </a>
            <a
              href={CONTACT.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-facebook"
              aria-label="Facebook"
              className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-3 shadow-soft border border-ink/5 font-semibold text-ink transition-all duration-300 hover:-translate-y-1 hover:text-brand-pink"
            >
              <Facebook className="w-5 h-5" /> Facebook
            </a>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram"
              aria-label="Instagram"
              className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-3 shadow-soft border border-ink/5 font-semibold text-ink transition-all duration-300 hover:-translate-y-1 hover:text-brand-pink"
            >
              <Instagram className="w-5 h-5" /> Instagram
            </a>
            <a
              href={CONTACT.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-tiktok"
              aria-label="TikTok"
              className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-3 shadow-soft font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:bg-black"
            >
              <TikTokIcon className="w-5 h-5" /> TikTok
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
